import { render, staticRenderFns } from "./Capacitacion.vue?vue&type=template&id=c5a2d116&"
import script from "./Capacitacion.vue?vue&type=script&lang=js&"
export * from "./Capacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports